<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style scoped lang="less">
@mt: 0.44rem;
#app{margin-top: @mt;}
</style>



// WEBPACK FOOTER //
// src/App.vue